import React from "react";
import style from "./woundReportCard.module.scss";
import infoIcon from "../../static/images/info.svg";
import constants from "../../constants/constants.json";

export const OverviewCard = ({ title, subTitle = "", selectedDivOption, optionSelected, selected, count1, count2 }) => {
  return (
    <div
      className={`crd_opt_1 ${style.overview_percentage} ${selectedDivOption === selected ? style.active : ""}`}
      onClick={() => optionSelected(selected)}
      data-testid="overview-card"
    >
      <div className="d-flex">
        <label className={style.dash_top}>
          {title} {subTitle}
        </label>
        {selected === "Pressure Injury POA" && (
          <span className={`${style.tooltip}`}>
            <img src={infoIcon} alt="info" />
            <span class={`${style.tooltiptext}`}>{constants.woundReport.allPressureInjuriesInfo}</span>
          </span>
        )}
      </div>
      <p className={style.dash_btm}>
        <span className={!count2 ? style.w_100 : ""}>{count1}</span>
        {count2 && <span>{count2}</span>}
      </p>
    </div>
  );
};
